import { UserListFilters } from '@hakimo-ui/hakimo/types';
import {
  SetPageAction,
  SET_PAGE,
  UpdateFiltersAction,
  UPDATE_FILTERS,
} from './actions';

export function createUpdateFiltersAction(
  payload: UserListFilters
): UpdateFiltersAction {
  return {
    type: UPDATE_FILTERS,
    payload,
  };
}

export function createSetPageAction(payload: number): SetPageAction {
  return {
    type: SET_PAGE,
    payload,
  };
}
